import {Injectable} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import { HttpClient } from '@angular/common/http';
import {ProjectId, ResourceId} from '../../types/ids';
import {Observable} from 'rxjs';
import {isDefined} from '../../utils/utils';
import {Feedable, SearchResults} from '../../types/searchresult';

@Injectable()
export class SearchApi {

    constructor (public OAuth2AuthService: AuthService, private http: HttpClient) { }

    simpleSearch(projectId: ProjectId, query: string, from?: number, size?: number, resourceType?: string): Observable<SearchResults> {
        let params = {
            query: query
        };
        if (isDefined(resourceType)) params['type'] = resourceType;
        if (isDefined(from)) params['from'] = from;
        if (isDefined(size)) params['size'] = size;
        return this.http.get<SearchResults>(`/projects/${projectId}/search`, { params });
    }

    getFeedable(projectId: ProjectId, resourceId: ResourceId): Observable<Feedable> {
        return this.http.get<Feedable>(`/projects/${projectId}/search/${resourceId}`);
    }

}
